jQuery(document).ready(function( $ ){
    $("a[href='https://americachip.com/shop/']").attr('href', 'https://americachip.com/');
  });
  